/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Local_PathInputs */

const en_media_local_path = /** @type {(inputs: Media_Local_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media Local Path`)
};

const fr_media_local_path = /** @type {(inputs: Media_Local_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chemin local du média`)
};

const de_media_local_path = /** @type {(inputs: Media_Local_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medien lokaler Pfad`)
};

const it_media_local_path = /** @type {(inputs: Media_Local_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percorso locale multimediale`)
};

const ru_media_local_path = /** @type {(inputs: Media_Local_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Локальный путь к медиафайлу`)
};

const es_media_local_path = /** @type {(inputs: Media_Local_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruta local de medios`)
};

const zh_cn2_media_local_path = /** @type {(inputs: Media_Local_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体本地路径`)
};

const ja_media_local_path = /** @type {(inputs: Media_Local_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアのローカルパス`)
};

const hi_media_local_path = /** @type {(inputs: Media_Local_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया लोकल पाथ`)
};

const pt_pt2_media_local_path = /** @type {(inputs: Media_Local_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caminho Local de Mídia`)
};

/**
* | output |
* | --- |
* | "Media Local Path" |
*
* @param {Media_Local_PathInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_local_path = /** @type {((inputs?: Media_Local_PathInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Local_PathInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_local_path(inputs)
	if (locale === "de") return de_media_local_path(inputs)
	if (locale === "it") return it_media_local_path(inputs)
	if (locale === "ru") return ru_media_local_path(inputs)
	if (locale === "es") return es_media_local_path(inputs)
	if (locale === "zh-CN") return zh_cn2_media_local_path(inputs)
	if (locale === "ja") return ja_media_local_path(inputs)
	if (locale === "hi") return hi_media_local_path(inputs)
	if (locale === "pt-PT") return pt_pt2_media_local_path(inputs)
	return en_media_local_path(inputs)
});